// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../../assets/images/banner/gentleman.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#banner-section {
  padding: 0px 10%;
}

.banner {
  background: transparent linear-gradient(6deg, #7062f9 0%, #8d81fa 100%) 0% 0% no-repeat padding-box;
  border-radius: 45px;
  opacity: 1;
}

.floating-btn {
  margin-left: -8%;
  bottom: 0;
  margin-bottom: 5%;
}

.magic-ward-btn {
  width: 220px !important;
  padding-right: 10px !important;
  text-align: left;
  border-radius: 40px;
}

.magic-ward {
  margin-left: -18%;
}

.animate-lottie {
  transform: rotate(-40deg);
  width: 140px;
  height: 100%;
}

.banner-col-1-text {
  font-size: 50px;
}

.background-image-col-wish {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: right;
  width: 500px;
  height: 455px;
  position: absolute;
  bottom: -11.5%;
}

.card-hover {
  width: 200px;
  height: 210px;
  border-radius: 30px;
  margin-top: 8% !important;
}

.orange-spot {
  height: 10px;
  background: salmon;
}

.spot {
  position: absolute;
  margin-top: -10% !important;
  background: salmon;
}

.handshake {
  width: 230px;
  margin-left: -35% !important;
  margin-top: -60% !important;
}

.card-on-hover-footer {
  margin-top: -20%;
}

@media only screen and (max-width: 1549px) {
  .background-image-col-wish {
    bottom: -11%;
  }
}
@media only screen and (max-width: 1479px) {
  .background-image-col-wish {
    bottom: -10%;
  }
  .banner-col-1-text {
    width: 150% !important;
  }
}
@media only screen and (max-width: 1445px) {
  .background-image-col-wish {
    bottom: -9%;
  }
}
@media only screen and (max-width: 1399px) {
  .background-image-col-wish {
    bottom: -11%;
  }
  .card-hover {
    margin-top: 7% !important;
    margin-left: 0% !important;
  }
  .download-btn {
    font-size: 12px !important;
  }
  .banner-col-1-text {
    font-size: 35px !important;
  }
  .get-app-btn {
    margin: 10px 0px !important;
  }
}
@media only screen and (max-width: 1357px) {
  .background-image-col-wish {
    bottom: -11%;
  }
}
@media only screen and (max-width: 1339px) {
  .background-image-col-wish {
    bottom: -11%;
  }
}
@media only screen and (max-width: 1264px) {
  .background-image-col-wish {
    bottom: -11%;
  }
}
@media only screen and (max-width: 1199px) {
  .background-image-col-wish {
    bottom: -13%;
  }
  .card-hover {
    margin-top: 7% !important;
    margin-left: 7% !important;
  }
  .download-btn {
    font-size: 12px !important;
  }
  .banner-col-1-text {
    font-size: 35px !important;
  }
  .get-app-btn {
    margin: 10px 0px !important;
  }
}
@media only screen and (max-width: 1129px) {
  .banner {
    height: 500px !important;
  }
  .background-image-col-wish {
    background: none !important;
  }
  .card-hover {
    width: 200px;
    height: 210px;
    border-radius: 30px;
    margin-top: 25% !important;
  }
}
@media only screen and (max-width: 1099px) {
  .card-hover {
    border-radius: 30px;
    margin-top: 25% !important;
    margin-left: -25% !important;
  }
}
@media only screen and (max-width: 1050px) {
  .card-hover {
    border-radius: 30px;
    margin-top: 25% !important;
    margin-left: -35% !important;
  }
}
@media only screen and (max-width: 991px) {
  .background-image-col-wish {
    background-image: none !important;
  }
  .banner {
    height: 400px !important;
  }
  .card-hover {
    margin-top: 20% !important;
    margin-left: -35% !important;
  }
  .download-btn {
    font-size: 12px !important;
  }
  .banner-text {
    font-size: 27px !important;
  }
  .banner-text-sub {
    font-size: 17px !important;
  }
  .get-app-btn {
    margin: 10px 0px !important;
  }
  .banner {
    padding: 0px 0px !important;
  }
  .magic-ward {
    margin-left: -15% !important;
    margin-top: -2% !important;
  }
  .magic-ward-btn {
    margin: 30px 0px !important;
  }
}
@media only screen and (max-width: 899px) {
  .card-hover {
    border-radius: 30px;
    margin-top: 25% !important;
    margin-left: -35% !important;
  }
}
@media only screen and (max-width: 855px) {
  .card-hover {
    border-radius: 30px;
    margin-top: 25% !important;
    margin-left: -45% !important;
  }
}
@media only screen and (max-width: 774px) {
  .card-hover {
    border-radius: 30px;
    margin-top: 25% !important;
    margin-left: 70% !important;
  }
}
@media only screen and (max-width: 769px) {
  .card-hover {
    border-radius: 30px;
    margin-top: 25% !important;
    margin-left: 70% !important;
  }
}
@media only screen and (max-width: 767px) {
  .download-btn {
    font-size: 12px !important;
  }
  .banner-col-1-text {
    font-size: 30px !important;
  }
  .get-app-btn {
    margin: 10px 0px !important;
  }
  .magic-ward {
    margin-left: 44% !important;
    margin-top: -35% !important;
  }
  .magic-ward-btn {
    margin: 30px 0px !important;
  }
  .btn-ward-section {
    justify-content: center;
  }
  .banner-text-sub {
    font-weight: lighter !important;
    font-size: 15px !important;
  }
  .text-link {
    font-size: 12px !important;
    font-weight: lighter !important;
  }
}
@media only screen and (max-width: 620px) {
  .promo-section {
    padding: 0% 0% !important;
  }
  .shimmer-container {
    padding: 0% 0% !important;
  }
  #banner-section {
    width: 100% !important;
    padding: 0px 0% !important;
  }
  .banner {
    border-radius: 0% !important;
    padding: 0% !important;
    margin: 0% !important;
    width: 100% !important;
  }
  .banner-col-1-text .banner-text {
    font-size: 40px !important;
  }
}
@media only screen and (max-width: 514px) {
  .magic-ward {
    margin-left: 45% !important;
    margin-top: -35% !important;
  }
}
@media only screen and (max-width: 460px) {
  .download-btn {
    font-size: 12px !important;
  }
  .get-app-btn {
    margin: 10px 0px !important;
  }
  .magic-ward {
    margin-left: 44% !important;
    margin-top: -54% !important;
  }
  .magic-ward-btn {
    margin: 30px 0px !important;
  }
  .btn-ward-section {
    justify-content: center;
  }
}
@media only screen and (max-width: 460px) {
  .magic-ward {
    margin-left: 45% !important;
    margin-top: -35% !important;
  }
}
@media only screen and (max-width: 440px) {
  .magic-ward {
    margin-left: 45% !important;
    margin-top: -38% !important;
  }
}
@media only screen and (max-width: 430px) {
  .download-btn {
    font-size: 12px !important;
  }
  .banner-col-1-text {
    font-size: 30px !important;
  }
  .get-app-btn {
    margin: 10px 0px !important;
  }
  .magic-ward {
    margin-left: 30% !important;
    margin-top: -25% !important;
    width: 50px !important;
    height: 100px !important;
  }
  .magic-ward-btn {
    margin: 10px 0px !important;
    padding: 15px 25px !important;
  }
  .btn-ward-section {
    justify-content: center;
  }
  .link {
    text-align: center;
  }
  .banner {
    padding: 15px 0px !important;
    margin: 0% 0% !important;
  }
}
@media only screen and (max-width: 410px) {
  .download-btn {
    font-size: 12px !important;
  }
  .banner-text {
    font-size: 25px !important;
    line-height: 15px;
  }
  .banner-text-sub {
    font-size: 15px !important;
  }
  .get-app-btn {
    margin: 10px 0px !important;
  }
  .magic-ward {
    margin-left: 30% !important;
    margin-top: -28% !important;
    width: 50px !important;
    height: 100px !important;
  }
  .magic-ward-btn {
    margin: 10px 0px !important;
    padding: 15px 25px !important;
  }
  .btn-ward-section {
    justify-content: center;
  }
  .link {
    text-align: center;
  }
}
@media only screen and (max-width: 365px) {
  .magic-ward {
    margin-left: 30% !important;
    margin-top: -34% !important;
    width: 50px !important;
    height: 100px !important;
  }
}
@media only screen and (max-width: 310px) {
  .magic-ward {
    margin-left: 30% !important;
    margin-top: -42% !important;
    width: 50px !important;
    height: 100px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/presentation/main/wishlist/components/banner/banner.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;EACE,mGAAA;EACA,mBAAA;EACA,UAAA;AACF;;AAEA;EACE,gBAAA;EACA,SAAA;EACA,iBAAA;AACF;;AAEA;EACE,uBAAA;EAEA,8BAAA;EACA,gBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAIA;EACE,yDAAA;EACD,4BAAA;EACA,wBAAA;EACA,0BAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AADD;;AAQA;EACC,YAAA;EACD,aAAA;EACA,mBAAA;EACA,yBAAA;AALA;;AAQA;EAEC,YAAA;EACA,kBAAA;AAND;;AASA;EACC,kBAAA;EACA,2BAAA;EACA,kBAAA;AAND;;AAiCA;EACC,YAAA;EACA,4BAAA;EACA,2BAAA;AA9BD;;AAiCA;EACE,gBAAA;AA9BF;;AAiCA;EACE;IACC,YAAA;EA9BD;AACF;AAiCA;EACE;IACC,YAAA;EA/BD;EAkCA;IACE,sBAAA;EAhCF;AACF;AAqCA;EACE;IACC,WAAA;EAnCD;AACF;AAsCA;EACE;IACE,YAAA;EApCF;EAuCD;IACD,yBAAA;IACA,0BAAA;EArCE;EAyCD;IACD,0BAAA;EAvCE;EA0CD;IACC,0BAAA;EAxCA;EA4CF;IACE,2BAAA;EA1CA;AACF;AA8CA;EACE;IACE,YAAA;EA5CF;AACF;AAuDA;EACE;IACE,YAAA;EArDF;AACF;AAwDA;EACE;IACE,YAAA;EAtDF;AACF;AA2DA;EACE;IACE,YAAA;EAzDF;EA4DD;IACD,yBAAA;IACA,0BAAA;EA1DE;EA8DD;IACD,0BAAA;EA5DE;EA+DD;IACC,0BAAA;EA7DA;EAiEF;IACE,2BAAA;EA/DA;AACF;AAmEA;EAEE;IACG,wBAAA;EAlEH;EAoEA;IACC,2BAAA;EAlED;EAsEA;IACE,YAAA;IACD,aAAA;IACA,mBAAA;IACA,0BAAA;EApED;AACF;AAwEA;EACE;IACC,mBAAA;IACA,0BAAA;IACA,4BAAA;EAtED;AACF;AAyEA;EACE;IACC,mBAAA;IACA,0BAAA;IACA,4BAAA;EAvED;AACF;AA4EA;EACE;IACE,iCAAA;EA1EF;EA+EA;IACE,wBAAA;EA7EF;EAgFD;IACD,0BAAA;IACA,4BAAA;EA9EE;EAkFD;IACD,0BAAA;EAhFE;EAmFD;IACC,0BAAA;EAjFA;EAqFF;IACE,0BAAA;EAnFA;EAsFF;IACE,2BAAA;EApFA;EAuFF;IACE,2BAAA;EArFA;EAwFF;IACE,4BAAA;IACA,0BAAA;EAtFA;EAyFF;IACE,2BAAA;EAvFA;AACF;AA6FA;EACE;IACC,mBAAA;IACA,0BAAA;IACA,4BAAA;EA3FD;AACF;AA8FA;EACE;IACC,mBAAA;IACA,0BAAA;IACA,4BAAA;EA5FD;AACF;AAgGA;EACE;IACC,mBAAA;IACA,0BAAA;IACA,2BAAA;EA9FD;AACF;AAkGA;EACE;IACC,mBAAA;IACA,0BAAA;IACA,2BAAA;EAhGD;AACF;AAmGA;EAEC;IACD,0BAAA;EAlGE;EAqGD;IACC,0BAAA;EAnGA;EAuGF;IACE,2BAAA;EArGA;EAwGF;IACE,2BAAA;IACA,2BAAA;EAtGA;EAyGF;IACE,2BAAA;EAvGA;EA0GF;IACE,uBAAA;EAxGA;EA2GF;IACE,+BAAA;IACA,0BAAA;EAzGA;EA4GF;IACE,0BAAA;IACA,+BAAA;EA1GA;AACF;AA+GA;EACE;IACE,yBAAA;EA7GF;EAgHA;IACE,yBAAA;EA9GF;EAiHA;IACE,sBAAA;IACA,0BAAA;EA/GF;EAkHE;IACE,4BAAA;IACA,sBAAA;IACA,qBAAA;IACA,sBAAA;EAhHJ;EAmHI;IACE,0BAAA;EAjHN;AACF;AAsHA;EACE;IACE,2BAAA;IACA,2BAAA;EApHF;AACF;AAwHA;EAGE;IACD,0BAAA;EAxHC;EAgID;IACE,2BAAA;EA9HD;EAiID;IACE,2BAAA;IACA,2BAAA;EA/HD;EAkID;IACE,2BAAA;EAhID;EAmID;IACE,uBAAA;EAjID;AACF;AAuIC;EACC;IACE,2BAAA;IACA,2BAAA;EArIF;AACF;AA0IA;EACE;IACE,2BAAA;IACA,2BAAA;EAxIF;AACF;AA2IC;EAGC;IACD,0BAAA;EA3IC;EA8IA;IACC,0BAAA;EA5ID;EAgJD;IACE,2BAAA;EA9ID;EAiJD;IACE,2BAAA;IACA,2BAAA;IACA,sBAAA;IACA,wBAAA;EA/ID;EAkJD;IACE,2BAAA;IACA,6BAAA;EAhJD;EAmJD;IACE,uBAAA;EAjJD;EAoJD;IACC,kBAAA;EAlJA;EAqJD;IACC,4BAAA;IACA,wBAAA;EAnJA;AACF;AAuJC;EAGC;IACD,0BAAA;EAvJC;EA0JA;IACC,0BAAA;IACA,iBAAA;EAxJD;EA4JD;IACC,0BAAA;EA1JA;EA6JD;IACE,2BAAA;EA3JD;EA8JD;IACE,2BAAA;IACA,2BAAA;IACA,sBAAA;IACA,wBAAA;EA5JD;EA+JD;IACE,2BAAA;IACA,6BAAA;EA7JD;EAgKD;IACE,uBAAA;EA9JD;EAiKD;IACC,kBAAA;EA/JA;AACF;AAiLC;EACC;IACE,2BAAA;IACA,2BAAA;IACA,sBAAA;IACA,wBAAA;EA/KF;AACF;AAkLC;EACC;IACE,2BAAA;IACA,2BAAA;IACA,sBAAA;IACA,wBAAA;EAhLF;AACF","sourcesContent":["#banner-section{\n  padding:0px 10%;\n}\n\n.banner {\n  background: transparent linear-gradient(6deg, #7062f9 0%, #8d81fa 100%) 0% 0% no-repeat padding-box;\n  border-radius: 45px;\n  opacity: 1;\n}\n\n.floating-btn {\n  margin-left: -8%;\n  bottom: 0;\n  margin-bottom: 5%;\n}\n\n.magic-ward-btn {\n  width: 220px !important;\n  // padding:20px !important;\n  padding-right:10px !important;\n  text-align: left;\n  border-radius:40px ;\n}\n\n.magic-ward {\n  margin-left: -18%;\n}\n\n.animate-lottie {\n  transform: rotate(-40deg);\n  width: 140px;\n  height: 100%;\n}\n\n.banner-col-1-text{\n  font-size:50px;\n}\n\n\n.background-image-col-wish{\n  background-image: url(\"../../../../../assets/images/banner/gentleman.png\");\n background-repeat: no-repeat;\n background-size: contain;\n background-position: right;\n width:500px;\n height:455px;\n position:absolute;\n bottom:-11.5%;\n//  margin-left:20%;\n//  margin-top:-12%;\n\n // position:absolute;\n}\n\n.card-hover{\n width: 200px;\nheight: 210px;\nborder-radius: 30px;\nmargin-top:8% !important;\n}\n\n.orange-spot {\n // width: 10px;\n height: 10px;\n background: salmon;\n}\n\n.spot{\n position:absolute;\n margin-top:-10% !important;\n background: salmon;\n}\n\n// .alternating-images-on-hover {\n//  background-image: url(\"../../../../../assets/images/banner/handshake.json\");\n//  width: 100%;\n//  height: 220px;\n//  background-position: center;\n//  background-size: cover;\n//  background-repeat: no-repeat;\n//  position: absolute;\n//  left: -20%;\n//  margin-top:-40%;\n// }\n\n// .alternating-images-on-hover:hover {\n// //  background-image: url(\"../../../../../assets/images/banner/red-dress.png\");\n//  width: 220px;\n//  height: 220px;\n//  background-position: center;\n//  background-size: cover;\n//  background-repeat: no-repeat;\n//  position: absolute;\n//  left: -20%;\n//  margin-top:-50%;\n// }\n\n.handshake{\n width:230px;\n margin-left:-35% !important;\n margin-top:-60% !important;\n}\n\n.card-on-hover-footer{\n  margin-top:-20%;\n}\n\n@media only screen and (max-width: 1549px) {\n  .background-image-col-wish{\n   bottom:-11%;\n  }\n}\n\n@media only screen and (max-width: 1479px) {\n  .background-image-col-wish{\n   bottom:-10%;\n  }\n\n  .banner-col-1-text{\n    width:150% !important;\n  }\n\n}\n\n\n@media only screen and (max-width: 1445px) {\n  .background-image-col-wish{\n   bottom:-9%;\n  }\n}\n\n@media only screen and (max-width: 1399px) {\n  .background-image-col-wish{\n    bottom:-11%;\n  }\n\n .card-hover{\nmargin-top:7% !important;\nmargin-left: 0% !important;\n}\n\n\n .download-btn{\nfont-size:12px !important;\n }\n\n .banner-col-1-text {\n  font-size:35px !important;\n  \n}\n\n.get-app-btn{\n  margin:10px 0px !important;\n}\n}\n\n\n@media only screen and (max-width: 1357px) {\n  .background-image-col-wish{\n    bottom:-11%;\n  }\n\n  // .banner-col-1-text{\n  //   .text-break {\n  //     font-size: 40px !important;\n  //     line-height: 35px;\n  //   }\n   \n  // }\n}\n\n@media only screen and (max-width: 1339px) {\n  .background-image-col-wish{\n    bottom:-11%;\n  }\n}\n\n@media only screen and (max-width: 1264px) {\n  .background-image-col-wish{\n    bottom: -11%;\n  }\n}\n\n\n\n@media only screen and (max-width: 1199px) {\n  .background-image-col-wish{\n    bottom: -13%;\n  }\n\n .card-hover{\nmargin-top:7% !important;\nmargin-left: 7% !important;\n}\n\n\n .download-btn{\nfont-size:12px !important;\n }\n\n .banner-col-1-text {\n  font-size:35px !important;\n  \n}\n\n.get-app-btn{\n  margin:10px 0px !important;\n}\n}\n\n\n@media only screen and (max-width: 1129px) {\n\n  .banner{\n     height:500px !important;\n  }\n  .background-image-col-wish{\n   background: none !important;\n \n  }\n\n  .card-hover{\n    width: 200px;\n   height: 210px;\n   border-radius: 30px;\n   margin-top:25% !important;\n   }\n}\n\n\n@media only screen and (max-width: 1099px) {\n  .card-hover{\n   border-radius: 30px;\n   margin-top:25% !important;\n   margin-left: -25% !important;\n   }\n}\n\n@media only screen and (max-width: 1050px) {\n  .card-hover{\n   border-radius: 30px;\n   margin-top:25% !important;\n   margin-left: -35% !important;\n   }\n}\n\n\n\n@media only screen and (max-width: 991px) {\n  .background-image-col-wish{\n    background-image: none !important;\n\n    // position:absolute;\n  }\n\n  .banner{\n    height:400px !important;\n }\n\n .card-hover{\nmargin-top:20% !important;\nmargin-left: -35% !important;\n}\n\n\n .download-btn{\nfont-size:12px !important;\n }\n\n .banner-text {\n  font-size:27px !important;\n  \n}\n\n.banner-text-sub{\n  font-size:17px !important;\n}\n\n.get-app-btn{\n  margin:10px 0px !important;\n}\n\n.banner{\n  padding:0px 0px !important;\n}\n\n.magic-ward {\n  margin-left: -15% !important;\n  margin-top: -2% !important;\n}\n\n.magic-ward-btn{\n  margin:30px 0px !important;\n}\n\n\n}\n\n\n@media only screen and (max-width: 899px) {\n  .card-hover{\n   border-radius: 30px;\n   margin-top:25% !important;\n   margin-left: -35% !important;\n   }\n}\n\n@media only screen and (max-width: 855px) {\n  .card-hover{\n   border-radius: 30px;\n   margin-top:25% !important;\n   margin-left: -45% !important;\n   }\n}\n\n\n@media only screen and (max-width: 774px) {\n  .card-hover{\n   border-radius: 30px;\n   margin-top:25% !important;\n   margin-left: 70% !important;\n   }\n}\n\n\n@media only screen and (max-width: 769px) {\n  .card-hover{\n   border-radius: 30px;\n   margin-top:25% !important;\n   margin-left: 70% !important;\n   }\n}\n\n@media only screen and (max-width: 767px) {\n  \n .download-btn{\nfont-size:12px !important;\n }\n\n .banner-col-1-text {\n  font-size:30px !important;\n  \n}\n\n.get-app-btn{\n  margin:10px 0px !important;\n}\n\n.magic-ward {\n  margin-left: 44% !important;\n  margin-top: -35% !important;\n}\n\n.magic-ward-btn{\n  margin:30px 0px !important;\n}\n\n.btn-ward-section{\n  justify-content: center;\n}\n\n.banner-text-sub{\n  font-weight:lighter !important;\n  font-size: 15px !important;\n}\n\n.text-link{\n  font-size: 12px !important;\n  font-weight:lighter !important;\n}\n\n}\n\n\n@media only screen and (max-width: 620px) {\n  .promo-section{\n    padding:0% 0% !important;\n  }\n  \n  .shimmer-container{\n    padding:0% 0% !important;\n  }\n  \n  #banner-section{\n    width: 100% !important;\n    padding:0px 0% !important;\n    }\n\n    .banner{\n      border-radius: 0% !important;\n      padding:0% !important;\n      margin:0% !important;\n      width: 100% !important;\n    }\n    .banner-col-1-text {\n      .banner-text{\n        font-size:40px !important;\n      } \n    }\n}\n\n\n@media only screen and (max-width: 514px) {\n  .magic-ward {\n    margin-left: 45% !important;\n    margin-top: -35% !important;\n  }\n  \n}\n\n@media only screen and (max-width: 460px) {\n  \n\n  .download-btn{\n font-size:12px !important;\n  }\n \n//   .banner-col-1-text {\n//    font-size:30px !important;\n   \n//  }\n \n .get-app-btn{\n   margin:10px 0px !important;\n }\n \n .magic-ward {\n   margin-left: 44% !important;\n   margin-top: -54% !important;\n }\n \n .magic-ward-btn{\n   margin:30px 0px !important;\n }\n \n .btn-ward-section{\n   justify-content: center;\n }\n \n \n }\n \n\n @media only screen and (max-width: 460px) {\n  .magic-ward {\n    margin-left: 45% !important;\n    margin-top: -35% !important;\n  }\n  \n}\n\n\n@media only screen and (max-width: 440px) {\n  .magic-ward {\n    margin-left: 45% !important;\n    margin-top: -38% !important;\n  }\n  \n}\n @media only screen and (max-width: 430px) {\n  \n\n  .download-btn{\n font-size:12px !important;\n  }\n \n  .banner-col-1-text {\n   font-size:30px !important;\n   \n }\n \n .get-app-btn{\n   margin:10px 0px !important;\n }\n \n .magic-ward {\n   margin-left: 30% !important;\n   margin-top: -25% !important;\n   width:50px !important;\n   height:100px !important;\n }\n \n .magic-ward-btn{\n   margin:10px 0px !important;\n   padding:15px 25px !important;\n }\n \n .btn-ward-section{\n   justify-content: center;\n }\n \n .link{\n  text-align: center;\n }\n\n .banner{\n  padding:15px 0px !important;\n  margin:0% 0.0% !important\n }\n \n }\n\n @media only screen and (max-width: 410px) {\n  \n\n  .download-btn{\n font-size:12px !important;\n  }\n \n  .banner-text{\n   font-size:25px !important;\n   line-height: 15px;\n   \n }\n\n .banner-text-sub{\n  font-size:15px !important;\n }\n \n .get-app-btn{\n   margin:10px 0px !important;\n }\n \n .magic-ward {\n   margin-left: 30% !important;\n   margin-top: -28% !important;\n   width:50px !important;\n   height:100px !important;\n }\n \n .magic-ward-btn{\n   margin:10px 0px !important;\n   padding:15px 25px !important;\n }\n \n .btn-ward-section{\n   justify-content: center;\n }\n \n .link{\n  text-align: center;\n }\n\n//  .banner{\n//   padding:20px 10px !important;\n//  }\n \n }\n \n @media only screen and (max-width: 380px) {\n\n//  .banner{\n//   padding:0px 0px !important;\n//   height:380px !important;\n//  }\n \n }\n \n\n @media only screen and (max-width: 365px) {\n  .magic-ward {\n    margin-left: 30% !important;\n    margin-top: -34% !important;\n    width:50px !important;\n    height:100px !important;\n  }\n }\n\n @media only screen and (max-width: 310px) {\n  .magic-ward {\n    margin-left: 30% !important;\n    margin-top: -42% !important;\n    width:50px !important;\n    height:100px !important;\n  }\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
